/**
 * Returns a simple promise that will be resolved within a discrete timeout
 * @param timeout The timeout in millisecs
 */
export const sleepAsync = function () {
  let timeout = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 250;
  return new Promise(resolve => setTimeout(() => {
    resolve();
  }, timeout));
};
//# sourceMappingURL=sleep-async.js.map